/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_Item_Responding_DescInputs */

const en_privacy_section_3_item_responding_desc = /** @type {(inputs: Privacy_Section_3_Item_Responding_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact form submissions are sent to us via Resend (email delivery service) so we can reply to your questions`)
};

const lv_privacy_section_3_item_responding_desc = /** @type {(inputs: Privacy_Section_3_Item_Responding_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kontaktformas iesniegumi tiek nosūtīti mums caur Resend (e-pasta piegādes pakalpojums), lai mēs varētu atbildēt uz Jūsu jautājumiem`)
};

/**
* | output |
* | --- |
* | "contact form submissions are sent to us via Resend (email delivery service) so we can reply to your questions" |
*
* @param {Privacy_Section_3_Item_Responding_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_item_responding_desc = /** @type {((inputs?: Privacy_Section_3_Item_Responding_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_Item_Responding_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_item_responding_desc(inputs)
	return en_privacy_section_3_item_responding_desc(inputs)
});